import React, { useState } from "react";
import Icon from "./Icon";
import { setPinned } from "../pins";

// A little pushpin toggle. Works inside a link without following it.
export default function PinButton({
  uid,
  adId,
  pinned,
  withLabel = false,
}: {
  uid: string;
  adId: string;
  pinned: boolean;
  withLabel?: boolean;
}) {
  const [busy, setBusy] = useState(false);

  const toggle = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      await setPinned(uid, adId, !pinned);
    } catch (err) {
      console.error("Couldn't update pin:", err);
    }
    setBusy(false);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      className={`pin-button${pinned ? " is-pinned" : ""}${withLabel ? " with-label" : ""}`}
      aria-pressed={pinned}
      aria-label={pinned ? "Unpin this post" : "Pin this post"}
      title={pinned ? "Unpin" : "Pin to my favorites"}
    >
      <Icon name="pin" size={16} />
      {withLabel && <span>{pinned ? "Pinned" : "Pin it"}</span>}
    </button>
  );
}
